export default __webpack_public_path__ + "static/fall1 (5)-dc9d05800b7c02c2bc81cbecb33fa329.jpeg";